var map = {
	"./babel-polyfill": [
		113,
		33,
		25
	],
	"./babel-polyfill.ts": [
		113,
		33,
		25
	],
	"./element-closest": [
		114,
		26
	],
	"./element-closest.ts": [
		114,
		26
	],
	"./element-remove": [
		115,
		27
	],
	"./element-remove.ts": [
		115,
		27
	],
	"./events-polifyll": [
		116,
		28
	],
	"./events-polifyll.ts": [
		116,
		28
	],
	"./fetch-polyfill": [
		117,
		29
	],
	"./fetch-polyfill.ts": [
		117,
		29
	],
	"./nodelist-foreach-polyfill": [
		118,
		30
	],
	"./nodelist-foreach-polyfill.ts": [
		118,
		30
	],
	"./scrollTo-polyfill": [
		119,
		31
	],
	"./scrollTo-polyfill.ts": [
		119,
		31
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 196;
module.exports = webpackAsyncContext;